import Hero from "../Hero";
import Details from "../Details";

const LandingPage = () => {
  return (
    <div>
      <Hero />
      <Details />
    </div>
  );
};

export default LandingPage;
